import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export default function ShippingSection() {
  const { t } = useTranslation('common');
  const location = useLocation();
  const lang = location.pathname.split('/')[1];
  const currentLang = ['en', 'pt', 'de'].includes(lang) ? lang : 'en';

  const rows = [
    { factor: 'shipping.weight', impact: 'shipping.weightImpact' },
    { factor: 'shipping.volume', impact: 'shipping.volumeImpact' },
    { factor: 'shipping.destination', impact: 'shipping.destinationImpact' },
    { factor: 'shipping.line', impact: 'shipping.lineImpact' },
    { factor: 'shipping.insurance', impact: 'shipping.insuranceImpact' },
    { factor: 'shipping.services', impact: 'shipping.servicesImpact' },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 font-heading mb-4">
              {t('shipping.h2')}
            </h2>
            <p className="text-foreground-600 leading-relaxed max-w-2xl mx-auto">
              {t('shipping.desc')}
            </p>
          </div>

          <div className="bg-background-100 rounded-xl border border-background-200 overflow-hidden mb-10">
            <div className="grid grid-cols-2 gap-0">
              <div className="px-6 py-4 bg-secondary-100 font-semibold text-sm text-foreground-800">
                {t('shipping.table.factor')}
              </div>
              <div className="px-6 py-4 bg-secondary-100 font-semibold text-sm text-foreground-800">
                {t('shipping.table.impact')}
              </div>
              {rows.map((row, i) => (
                <Fragment key={i}>
                  <div className="px-6 py-4 text-sm text-foreground-700 border-t border-background-200">
                    {t(row.factor)}
                  </div>
                  <div className="px-6 py-4 text-sm text-foreground-600 border-t border-background-200">
                    {t(row.impact)}
                  </div>
                </Fragment>
              ))}
            </div>
          </div>

          <div className="text-center">
            <a
              href={`/${currentLang}/articles/cssbuy-spreadsheet-guide`}
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap"
            >
              {t('shipping.cta')}
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}